import React from 'react';
import { AuthGate } from './AuthGate';
import { AppProviders } from './providers/AppProviders';

/**
 * IMPORTANT: The component hierarchy has been restructured to prevent screen refreshes
 * during token revalidation. The SentryProvider is positioned after AppApolloProvider
 * but before AuthGate to isolate it from token state changes while still having
 * access to Apollo Client.
 */
function App() {
  return (
    <AppProviders>
      <AuthGate/>
    </AppProviders>
  );
}

export default App;
